import {
  SearchFilterBlueprint,
} from '@backstage/plugin-search-react/alpha';
import { SearchFilter } from '@backstage/plugin-search-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const resourceTypeFilter = SearchFilterBlueprint.make({
  name: 'resource-type',
  params: {
    component: ({ className }: { className?: string }) => (
      <SearchFilter.Select
        className={className}
        label="Resource Type"
        name="type"
        values={['aws-account']}
      />
    ),
  },
});

export const searchModule = createFrontendModule({
  pluginId: 'search',
  extensions: [resourceTypeFilter],
});
